import { render, staticRenderFns } from "./DeliverDelay.vue?vue&type=template&id=1711e482&scoped=true&"
import script from "./DeliverDelay.vue?vue&type=script&lang=js&"
export * from "./DeliverDelay.vue?vue&type=script&lang=js&"
import style0 from "./DeliverDelay.vue?vue&type=style&index=0&id=1711e482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1711e482",
  null
  
)

export default component.exports